"use client"

import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import { ToastPosition, useToastStore } from "./store/useToastStore"
import { AnimatePresence, motion } from "framer-motion"

const ToastWrapper = ({
  position,
  children,
}: {
  children: React.ReactNode
  position: ToastPosition
}) => {
  if (position === "bottom") {
    return (
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
        transition={{ duration: 0.3 }}
        className="fixed bottom-5 left-1/2 z-10001 w-[90%] md:max-w-[768px]"
        style={{ x: "-50%" }}
      >
        {children}
      </motion.div>
    )
  } else if (position === "top") {
    return (
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        transition={{ duration: 0.3 }}
        className="fixed top-5 left-1/2 z-10001 w-[90%] md:max-w-[768px]"
        style={{ x: "-50%" }}
      >
        {children}
      </motion.div>
    )
  } else if (position === "center") {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.3 }}
        className="fixed top-1/2 left-1/2 z-10001 w-[90%] md:max-w-[768px]"
        style={{ x: "-50%", y: "-50%" }}
      >
        {children}
      </motion.div>
    )
  }
  return null
}

export default function ToastPortal() {
  const { isVisible, content: _content, position } = useToastStore()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  const toastRoot = document.getElementById("toast-root")
  if (!toastRoot) return null

  const content =
    typeof _content === "string" ? (
      <div className="bg-rl-common-black text-rl-common-white typo-rl-caption rounded-sm p-2 font-normal">
        {_content}
      </div>
    ) : (
      _content
    )

  return createPortal(
    <AnimatePresence>
      {isVisible && <ToastWrapper position={position}>{content}</ToastWrapper>}
    </AnimatePresence>,
    toastRoot as Element,
  )
}
